import { Box } from "@material-ui/core"
import HourReportActionButton from "../HourReportActionButton"
import { makeHourReportFormActionSettings } from "./form-action-settings"
import { useTranslation } from "react-i18next"

type Props = {
  onSaveAsDraft: () => void
  onSubmitReport: () => void
  isSubmitting: boolean
  showSaveAsDraft?: boolean
  supportsSubmission?: boolean
  supportsChecking?: boolean
  supportsApproval?: boolean
}

export const FormActions = ({
  onSaveAsDraft,
  onSubmitReport,
  isSubmitting,
  showSaveAsDraft = true,
  supportsSubmission = true,
  supportsChecking,
  supportsApproval,
}: Props) => {
  const { t } = useTranslation("hour-report")
  const settings = makeHourReportFormActionSettings({
    supportsSubmission,
    supportsChecking,
    supportsApproval,
    showSaveAsDraft,
    labels: {
      saveReport: t("actions.saveReport", { defaultValue: "Save report" }),
      submitForCheck: t("actions.submitForCheck", { defaultValue: "Submit for check" }),
      submitForApproval: t("actions.submitForApproval", { defaultValue: "Submit for approval" }),
    },
  })
  const onPrimaryAction = settings.primaryAction === "submit" ? onSubmitReport : onSaveAsDraft

  return (
    <Box mt={4} display="flex" justifyContent="flex-start" alignItems="center">
      <HourReportActionButton
        icon="send"
        color="primary"
        onClick={onPrimaryAction}
        style={{ marginRight: 8 }}
        disabled={isSubmitting}
      >
        {settings.primaryLabel}
      </HourReportActionButton>
      {settings.showSaveAsDraft ? (
        <HourReportActionButton icon="draft" onClick={onSaveAsDraft} disabled={isSubmitting}>
          {t("actions.saveAsDraft", { defaultValue: "Save as Draft" })}
        </HourReportActionButton>
      ) : null}
    </Box>
  )
}
